var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-page"},[_c('i',{staticClass:"el-icon-success success-icon"}),_c('p',{staticClass:"title"},[_vm._v("支付成功!")]),_c('span',{staticClass:"content"},[_vm._v("请返回上一页查看，"+_vm._s(_vm.time)+"秒后将关闭此页面")])])}
var staticRenderFns = []

export { render, staticRenderFns }